import React, { useState } from 'react'
import { BaseDialog } from '@/components/dialog/base-dialog'
import { layerManage, showLayer } from '@/utils/layer'
import SearchInput from '@/components/search-input/search-input'
import { Column, Expaned, Row } from '@/components/layout/layout'
import { getBEMCls } from '@/utils/classname'
import Iconfont from '@/components/iconfont/iconfont'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { $post } from '@/api'
import WordHighLight from '@/components/word-highlight/word-highlight'
import './choose-material-dialog.scss'
import classNames from 'classnames'
import { getFilesSizeMax, isExist } from '@/utils'
import { getQiniuImgUrl, getVideoPreviewUrl } from '@/config/qiniu'
import { WithScrollLoad } from '@/utils/utils-widget'
import { useRequest } from 'ahooks'
import { IPagination } from '@/model/types/common'
import UploadMaterial from '../upload-material/upload-material'
import Button from '@/components/button/button'
import useSelectList from '@/utils/hooks/useSelectList'
import $msg from '@/utils/message'
import SearchTipBox from '../../../mall-manage/component/search-box/search-box'

interface Group {
    id: number
    material_type: number
    name: string
    description: string
    priority: number
    is_default: boolean
}

export interface IMaterials {
    id: number
    group: Group
    name: string
    name_acronym: string
    url: string
    size: number
    status: number
    duration?: number
    play_count?: number
    proportion: string
}

export interface MaterialsList {
    list: IMaterials[]
    pagination: IPagination
}

export const ChooseMaterialDialog: React.FC<{
    onSelected?: (data: IMaterials) => void
    onChoose?: (data: IMaterials[]) => void
    type?: 'image' | 'video' | 'all'
    multipleChoose?: boolean
    maxCount?: number
}> = props => {
    const cls = (...args: string[]) => getBEMCls('choose-material', ...args)
    const [keyWord, setKeyWord] = useState('')
    const [type, setType] = useState(1) // 1 图片 2 视频 3 内置视频
    const [select, setSelect] = useState<IMaterials | null>(null)
    const multipleSelectAction = useSelectList<IMaterials>([], 'id')

    const columns: ColumnsType<IMaterials> = [
        {
            title: '',
            key: '1',
            width: '50px',
            render: (text, record) => (
                <div data-cursor-pointer>
                    <Iconfont
                        name={
                            props.multipleChoose
                                ? multipleSelectAction.has(record)
                                    ? 'icon3duoxuanerji-20'
                                    : 'icon3duoxuanguan-20'
                                : select?.id === record.id
                                ? 'icon3danxuankai-20'
                                : 'icon3danxuanguan-20'
                        }
                        size={20}
                    ></Iconfont>
                </div>
            ),
        },
        {
            title: '#',
            width: '50px',
            align: 'center',
            key: '2',
            render: (text, record, index) => {
                return <span>{index + 1}</span>
            },
        },
        {
            title: type === 2 ? '视频' : '图片',
            key: 'url',
            dataIndex: 'url',
            align: 'center',
            render: text => (
                <img
                    src={type === 2 ? getVideoPreviewUrl(text) : getQiniuImgUrl(text)}
                    alt=""
                    data-width-50
                    data-height-50
                />
            ),
        },
        {
            title: type === 2 ? '视频名称' : '图片名称',
            key: 'name',
            dataIndex: 'name',
            render: text => <WordHighLight keyword={keyWord} word={text}></WordHighLight>,
        },
        {
            title: '尺寸',
            align: 'right',
            dataIndex: 'proportion',
            render: text => <span>{text ? text : '暂无'}</span>,
        },
        {
            title: type === 2 ? '视频大小' : '图片大小',
            align: 'right',
            key: 'size',
            dataIndex: 'size',
            render: text => <span>{getFilesSizeMax(text)}</span>,
        },
    ]

    const requestHandle = useRequest<
        MaterialsList,
        {
            materials: IMaterials[]
            pagination: IPagination
        }
    >(
        val => {
            return $post({
                url: '/material/getmaterials',
                params: {
                    limit: 20,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    types: [type],
                    keyword: keyWord || void 0,
                },
            })
        },
        {
            isNoMore: data => {
                if (data?.pagination) {
                    return data?.pagination.page === data?.pagination.page_count
                } else {
                    return false
                }
            },
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.materials,
                    pagination: data.pagination,
                }
            },
            refreshDeps: [type, keyWord],
        },
    )

    const { data, loading } = requestHandle

    return (
        <BaseDialog styles={{ width: '714px' }} isShow title="素材库" onClose={() => layerManage.pop()}>
            <Column data-padding-h-24 data-padding-top-16 data-padding-bottom-32>
                <Row>
                    <Expaned>
                        <SearchInput
                            placeholder="输入关键词搜索素材"
                            onSearch={keyWord => {
                                setKeyWord(keyWord)
                            }}
                            onDelete={() => {
                                setKeyWord('')
                            }}
                        ></SearchInput>
                    </Expaned>
                    <div
                        className={cls('upload')}
                        onClick={() => {
                            layerManage.pop()
                            showLayer(<UploadMaterial />)
                        }}
                    >
                        <span data-margin-right-5>
                            <Iconfont name="iconshangchuan-copy" size={15}></Iconfont>
                        </span>
                        上传素材
                    </div>
                </Row>

                <Row className={cls('tabs')}>
                    <Row className={cls('tabs', 'wrapper')}>
                        {['image', 'all'].includes(props.type || '') && (
                            <div
                                className={classNames(cls('tabs', 'item1'), type === 1 ? cls('tabs', 'active') : '')}
                                onClick={() => setType(1)}
                            >
                                图片
                            </div>
                        )}
                        {['video', 'all'].includes(props.type || '') && (
                            <div
                                className={classNames(cls('tabs', 'item3'), type === 2 ? cls('tabs', 'active') : '')}
                                onClick={() => setType(2)}
                            >
                                视频
                            </div>
                        )}
                        {['image', 'all'].includes(props.type || '') && (
                            <div
                                className={classNames(cls('tabs', 'item2'), type === 3 ? cls('tabs', 'active') : '')}
                                onClick={() => setType(3)}
                            >
                                内置素材
                            </div>
                        )}
                    </Row>
                </Row>

                {keyWord && (
                    <SearchTipBox
                        keyWord={keyWord}
                        onClose={() => {
                            setKeyWord('')
                        }}
                        style={{
                            marginTop: '8px',
                        }}
                    />
                )}

                <div className={cls('wrapper')}>
                    <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                        <Table
                            columns={columns}
                            dataSource={data?.list}
                            pagination={false}
                            loading={loading || requestHandle.loadingMore || void 0}
                            bordered
                            scroll={{ y: 290, x: 'max-content' }}
                            rowKey={record => record.id}
                            onRow={record => {
                                return {
                                    onClick: () => {
                                        if (props.multipleChoose) {
                                            if (props.maxCount) {
                                                if (
                                                    !multipleSelectAction.has(record) &&
                                                    multipleSelectAction.select.length >= props.maxCount
                                                ) {
                                                    return $msg('warning', '已达最大选择数量限制')
                                                }
                                            }
                                            return multipleSelectAction.toggle(record)
                                        }
                                        setSelect(record)
                                    },
                                }
                            }}
                        />
                    </WithScrollLoad>
                    <Row className={cls('footer')}>
                        <Row>
                            {props.multipleChoose && (
                                <span data-font-size-14 data-color-000 data-row data-margin-left-10>
                                    已选
                                    <span data-padding-h-5 data-color-primary data-row>
                                        {multipleSelectAction.select.length}
                                        {props.maxCount ? `/${props.maxCount}` : ''}
                                    </span>
                                    个素材
                                </span>
                            )}
                        </Row>
                        <Button
                            types="default"
                            disabled={props.multipleChoose ? !isExist(multipleSelectAction.select) : !select?.id}
                            onClick={() => {
                                if (props.multipleChoose) {
                                    props.onChoose && props.onChoose(multipleSelectAction.select)
                                } else {
                                    // @ts-ignore
                                    props.onSelected && props.onSelected(select)
                                }
                            }}
                        >
                            确认
                        </Button>
                    </Row>
                </div>
            </Column>
        </BaseDialog>
    )
}

ChooseMaterialDialog.defaultProps = {
    type: 'image',
}
